module.exports = __webpack_public_path__ + "static/footer-1-7a77054e7a69dc05cebf49e149b3f713.mp4";